module.exports = __webpack_public_path__ + "static/media/francesco_top.41f6ec64.jpg";